import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root = ({ colorsV2, inputBorderV2 }: ExactTheme) => css({});
